import { useState } from "react";
import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Elena & Ricardo",
    location: "Ciudad de México",
    text: "Una experiencia absolutamente mágica. La atención al detalle, la belleza del lugar y la tranquilidad hicieron de nuestra estancia algo inolvidable. Volveremos sin duda.",
    rating: 5,
  },
  {
    name: "Familia Martínez",
    location: "Monterrey",
    text: "Celebramos un aniversario en Casa El Gavillero y superó todas nuestras expectativas. El servicio impecable, los espacios preciosos y la comida excepcional.",
    rating: 5,
  },
  {
    name: "Sofía Hernández",
    location: "Guadalajara",
    text: "El lugar perfecto para desconectar. Las vistas son espectaculares y cada rincón está diseñado con un gusto exquisito. Nos sentimos en casa desde el primer momento.",
    rating: 5,
  },
];

export default function Testimonios() {
  const { ref, isVisible } = useScrollReveal();
  const [active, setActive] = useState(0);

  const next = () => setActive((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setActive((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section className="py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-4xl mx-auto text-center" ref={ref}>
        <motion.span
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ duration: 1 }}
          className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
        >
          Testimonios
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1.2, delay: 0.1 }}
          className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance mb-16"
        >
          Voces de nuestros huéspedes
        </motion.h2>

        <div className="relative">
          <Quote size={48} className="text-accent/20 mx-auto mb-8" />

          <motion.div
            key={active}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex justify-center gap-1 mb-6">
              {Array.from({ length: TESTIMONIALS[active].rating }).map((_, i) => (
                <Star key={i} size={16} className="text-accent fill-accent" />
              ))}
            </div>
            <p className="font-serif-display text-2xl md:text-3xl text-foreground font-light italic leading-relaxed text-balance mb-8">
              "{TESTIMONIALS[active].text}"
            </p>
            <p className="text-foreground font-light text-lg">{TESTIMONIALS[active].name}</p>
            <p className="text-muted-foreground text-sm font-light">{TESTIMONIALS[active].location}</p>
          </motion.div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-10">
            <button onClick={prev} className="p-2 text-muted-foreground hover:text-accent transition-colors">
              <ChevronLeft size={24} />
            </button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`h-1.5 transition-all duration-300 ${
                    i === active ? "w-8 bg-accent" : "w-1.5 bg-border"
                  }`}
                />
              ))}
            </div>
            <button onClick={next} className="p-2 text-muted-foreground hover:text-accent transition-colors">
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}